/* =============================================================
   Pulse Performance — Pickup-point delivery selector
   Cart page only. Loaded via main-cart-footer.liquid.
   ============================================================= */
(function () {
  'use strict';

  /* ── State ─────────────────────────────────────────────────── */
  var state = {
    method:    null,  // 'zasilkovna' | 'ppl' | 'home' | null
    carrier:   '',
    pointId:   '',
    pointName: ''
  };

  var packetaScriptInjected = false;
  var debounceTimer         = null;
  var cartUpdateUnsubscriber = null;

  /* ── DOM refs (re-assigned after each cart re-render) ─────── */
  var selEl, radios, pointPanel, pickBtn,
      pointInfo, pointNameEl, changeBtn, hint,
      checkoutForm, pplWidgetEl;

  /* ── Boot ────────────────────────────────────────────────────── */
  /* init() is called once on page load. It handles one-time setup
     (pplWidget relocation, form and widget event listeners, Dawn
     pub/sub subscription). Per-render DOM work goes in attachSelectorListeners(). */
  function init() {
    selEl = document.getElementById('pp-pickup-selector');
    if (!selEl) return;

    pplWidgetEl = document.getElementById('pplWidget');

    /* Move the widget to <body> so its modal overlay escapes the
       cart footer's positioning context. Dawn's .isolate class sets
       position:relative on .cart__footer, making it the containing
       block for our position:absolute widget — the modal then renders
       inside the narrow cart column instead of full-viewport. */
    if (pplWidgetEl && pplWidgetEl.parentNode !== document.body) {
      document.body.appendChild(pplWidgetEl);
    }

    checkoutForm = document.getElementById('cart');

    /* PPL widget events — attached once; the widget element stays at
       <body> across cart re-renders (it's outside the .js-contents
       swap target) so listeners persist without re-attachment. */
    if (pplWidgetEl) {
      pplWidgetEl.addEventListener('ppl-accesspointwidget-select', onPplSelect);
      pplWidgetEl.addEventListener('ppl-accesspointwidget-error',  onPplError);
      pplWidgetEl.addEventListener('ppl-accesspointwidget-ready', function () {});
      /* Safety net: guarantee body scroll is restored whenever modal closes,
         regardless of how it was closed (X button, backdrop, ESC key). */
      pplWidgetEl.addEventListener('ppl-accesspointwidget-close', function () {
        releasePplOverlay();
      });
    }

    /* Checkout gating — the <form id="cart"> element is inside
       main-cart-items which is independently re-rendered; the element
       itself persists so this listener doesn't need re-attachment. */
    if (checkoutForm) {
      checkoutForm.addEventListener('submit', onFormSubmit);
    }

    /* Initial selector wiring */
    attachSelectorListeners(/* fromSSR */ true);

    /* Subscribe to Dawn's cart-update pub/sub so we can re-wire the
       pickup selector after each quantity-change AJAX re-render.
       Dawn swaps #main-cart-footer .js-contents, which recreates
       #pp-pickup-selector and its children — event listeners are lost
       and must be re-attached. */
    if (!cartUpdateUnsubscriber
        && typeof subscribe !== 'undefined'
        && typeof PUB_SUB_EVENTS !== 'undefined') {
      cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'cart-items') {
          reinitSelector();
        }
      });
    }
  }

  /* ── Re-init after Dawn cart re-render ──────────────────────── */
  /* Called after each AJAX quantity change that swaps .js-contents.
     Skips pplWidget and form — those are one-time. */
  function reinitSelector() {
    selEl = document.getElementById('pp-pickup-selector');
    if (!selEl) return;
    attachSelectorListeners(/* fromSSR */ false);
  }

  /* ── Per-render selector wiring ─────────────────────────────── */
  /* fromSSR=true on page load: restore state from data-* attributes
     (server-rendered cart.attributes). fromSSR=false after a AJAX
     re-render: the DOM has fresh HTML but state{} already holds the
     user's current selection, so we use that instead to avoid a race
     with the 300ms saveAttributes debounce. */
  function attachSelectorListeners(fromSSR) {
    radios      = Array.prototype.slice.call(selEl.querySelectorAll('input[name="pp-delivery"]'));
    pointPanel  = selEl.querySelector('.pp-pickup__point-panel');
    pickBtn     = selEl.querySelector('.pp-pickup__pick-btn');
    pointInfo   = selEl.querySelector('.pp-pickup__point-info');
    pointNameEl = selEl.querySelector('.pp-pickup__point-name');
    changeBtn   = selEl.querySelector('.pp-pickup__change-btn');
    hint        = selEl.querySelector('.pp-pickup__hint');

    if (fromSSR) {
      /* First load: pull persisted selection from cart.attributes via
         server-rendered data-* attributes on the selector root. */
      var ssrMethod = selEl.dataset.method;
      if (ssrMethod) {
        state.method    = ssrMethod;
        state.carrier   = selEl.dataset.carrier   || '';
        state.pointId   = selEl.dataset.pointId   || '';
        state.pointName = selEl.dataset.pointName || '';
      }
    }

    /* Tick the correct radio (uses current state regardless of source) */
    if (state.method) {
      radios.forEach(function (r) {
        r.checked = (r.value === state.method);
      });
    }

    renderPanel();

    /* Radio changes */
    radios.forEach(function (r) {
      r.addEventListener('change', onMethodChange);
    });

    /* Pick / Change buttons */
    if (pickBtn)   pickBtn.addEventListener('click', onPickClick);
    if (changeBtn) changeBtn.addEventListener('click', onPickClick);
  }

  /* ── Radio change ───────────────────────────────────────────── */
  function onMethodChange(e) {
    var next = e.target.value;
    var prev = state.method;

    /* Clear stale point whenever method changes */
    if (next !== prev) {
      state.carrier   = '';
      state.pointId   = '';
      state.pointName = '';
    }

    state.method = next;
    renderPanel();
    updateHint(false);
    saveAttributes();
  }

  /* ── Pick / Change click ────────────────────────────────────── */
  function onPickClick() {
    if (state.method === 'zasilkovna' || state.method === 'ro_pickup') openPacketa();
    if (state.method === 'ppl')        openPpl();
  }

  /* ── Zásilkovna (Packeta) ───────────────────────────────────── */
  function openPacketa() {
    var apiKey      = selEl.dataset.packetaKey;
    var pktCountry  = selEl.dataset.packetaCountry  || 'cz';
    var pktLanguage = selEl.dataset.packetaLanguage || 'cs';
    var pktVendors;
    try { pktVendors = JSON.parse(selEl.dataset.packetaVendors || 'null'); } catch (e) { pktVendors = null; }
    if (!pktVendors || !pktVendors.length) { pktVendors = [{ country: 'cz', group: 'zbox' }, { country: 'cz' }]; }

    function doOpen() {
      Packeta.Widget.pick(apiKey, onPacketaSelect, {
        country:  pktCountry,
        language: pktLanguage,
        view:     'modal',
        vendors:  pktVendors
      });
    }

    if (typeof Packeta !== 'undefined' && Packeta.Widget) {
      doOpen();
    } else if (!packetaScriptInjected) {
      packetaScriptInjected = true;
      loadScript('https://widget.packeta.com/v6/www/js/library.js', doOpen);
    }
  }

  function onPacketaSelect(point) {
    if (!point) return; /* user dismissed modal without picking */

    /* Log full shape once so Lukas can confirm real field names */
    if (!onPacketaSelect._logged) {
      console.log('[pickup-selector] Packeta point object:', point);
      console.log('[pickup-selector] carrierId:', point.carrierId,
                  '| carrierPickupPointId:', point.carrierPickupPointId);
      onPacketaSelect._logged = true;
    }

    var name = point.formatedValue || /* note: Packeta's real spelling (one 't') */
               [point.name, point.street, point.city].filter(Boolean).join(', ');

    state.carrier   = 'zasilkovna';
    state.pointId   = String(point.id);
    state.pointName = name;

    renderPanel();
    saveAttributes();
  }

  /* ── PPL widget 2.0 ─────────────────────────────────────────── */
  /* Loader is included statically in main-cart-footer.liquid.
     CE may finish registering async after the loader executes,
     so use whenDefined() as the safe wait mechanism. */
  function openPpl() {
    if (!pplWidgetEl) return;

    /* Force full-viewport sizing before opening. The widget's :host
       uses height:100%, which collapses to ~0 because the element was
       moved to <body> (so its modal escapes the cart column) and body
       has no explicit height. Result: map container gets 0 height —
       mobile shows only the list, desktop renders nothing but still
       scroll-locks the page (freeze). vw/vh units don't depend on any
       ancestor height, so they restore full-screen rendering. */
    pplWidgetEl.style.position      = 'fixed';
    pplWidgetEl.style.top           = '0';
    pplWidgetEl.style.left          = '0';
    pplWidgetEl.style.width         = '100vw';
    pplWidgetEl.style.height        = '100vh';
    pplWidgetEl.style.zIndex        = '999999';
    pplWidgetEl.style.pointerEvents = 'auto';

    if (customElements.get('ppl-access-point-widget')) {
      pplWidgetEl.open();
    } else {
      customElements.whenDefined('ppl-access-point-widget').then(function () {
        pplWidgetEl.open();
      });
    }
  }

  function onPplSelect(e) {
    var detail = e.detail;

    /* Log full shape once — field names are nullable per docs */
    if (!onPplSelect._logged) {
      console.log('[pickup-selector] PPL point detail:', JSON.stringify(detail, null, 2));
      onPplSelect._logged = true;
    }

    /* detail.code = stable point identifier (KM + 7 digits format) */
    var id = detail.code || '';

    var addr = detail.address || {};
    var name = [detail.name, addr.street, addr.city]
                 .filter(Boolean).join(', ');

    state.carrier   = 'ppl';
    state.pointId   = id;
    state.pointName = name;

    /* Close + FULLY neutralize the widget. The select path does not fire
       the 'close' event, so the scroll-lock (body.overflow:hidden set on
       open) is never released AND the full-viewport sizing we force at
       open (fixed, inset:0, z-index:999999, pointer-events:auto) keeps the
       closed element covering the page — blocking all clicks (can't reach
       "K PLATBĚ", can't scroll). We must undo both here. */
    if (typeof pplWidgetEl.close === 'function') {
      pplWidgetEl.close();
    }
    releasePplOverlay();

    renderPanel();
    saveAttributes();
  }

  /* Restore page interactivity after the PPL modal closes by any path
     (select, X button, backdrop, ESC). Reverses the open-time overrides. */
  function releasePplOverlay() {
    document.body.style.overflow = '';
    if (pplWidgetEl) {
      pplWidgetEl.style.pointerEvents = 'none';
      pplWidgetEl.style.width  = '0';
      pplWidgetEl.style.height = '0';
    }
  }

  function onPplError(e) {
    var detail  = e.detail || {};
    var code    = detail.code    || '';
    var message = detail.message || '';
    console.error('[pickup-selector] PPL widget error', code, message);

    /* Friendly Czech message — most likely cause: domain not whitelisted */
    var errEl = pointPanel && pointPanel.querySelector('.pp-pickup__error');
    if (!errEl && pointPanel) {
      errEl = document.createElement('p');
      errEl.className = 'pp-pickup__error';
      pointPanel.appendChild(errEl);
    }
    if (errEl) {
      errEl.textContent =
        'Načtení mapy výdejních míst PPL se nezdařilo.' +
        ' Zkontroluj připojení nebo nás kontaktuj.';
    }
  }

  /* ── Render ─────────────────────────────────────────────────── */
  function renderPanel() {
    if (!pointPanel) return;

    var isPickup = (state.method === 'zasilkovna' || state.method === 'ppl' || state.method === 'ro_pickup');
    pointPanel.classList.toggle('is-visible', isPickup);
    if (!isPickup) return;

    var hasPoint = Boolean(state.pointId && state.pointName);

    if (pickBtn) pickBtn.style.display = hasPoint ? 'none' : '';

    if (pointInfo) {
      pointInfo.classList.toggle('is-visible', hasPoint);
    }
    if (hasPoint && pointNameEl) {
      pointNameEl.textContent = state.pointName;
    }

    /* Clear any previous error when re-opening */
    if (!hasPoint) {
      var errEl = pointPanel.querySelector('.pp-pickup__error');
      if (errEl) errEl.textContent = '';
    }
  }

  /* ── Checkout gating ─────────────────────────────────────────── */
  function onFormSubmit(e) {
    /* Gate only the checkout button, not quantity updates.
       e.submitter may be null on very old browsers — treat
       unknown submitters conservatively (also gate). */
    var isCheckout = !e.submitter
      || e.submitter.id   === 'checkout'
      || e.submitter.name === 'checkout';

    if (isCheckout && !isDeliveryReady()) {
      e.preventDefault();
      updateHint(true);
      selEl && selEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function isDeliveryReady() {
    if (!state.method) return false;
    if (state.method === 'home' || state.method === 'ro_home') return true;
    return Boolean(state.pointId && state.pointName);
  }

  function updateHint(show) {
    if (hint) hint.classList.toggle('is-visible', show);
  }

  /* ── Cart attribute persistence ─────────────────────────────── */
  function saveAttributes() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      var body = JSON.stringify({
        attributes: {
          delivery_method:      state.method    || '',
          pickup_point_carrier: state.carrier   || '',
          pickup_point_id:      state.pointId   || '',
          pickup_point_name:    state.pointName || ''
        }
      });

      fetch('/cart/update.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    body
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          /* Re-sync from POST response — it is the source of truth */
          if (cart && cart.attributes) {
            var a = cart.attributes;
            state.method    = a.delivery_method      || state.method;
            state.carrier   = a.pickup_point_carrier || '';
            state.pointId   = a.pickup_point_id      || '';
            state.pointName = a.pickup_point_name    || '';
            renderPanel();
          }
        })
        .catch(function (err) {
          console.error('[pickup-selector] /cart/update.js failed:', err);
        });
    }, 300);
  }

  /* ── Utility ─────────────────────────────────────────────────── */
  function loadScript(src, cb) {
    var s    = document.createElement('script');
    s.src    = src;
    s.async  = true;
    if (cb) s.onload = cb;
    document.head.appendChild(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
